const numberRegex = /^\d+$/;

export const makeValidateRange =
  (min: number, max: number) =>
  (value: string): boolean => {
    const numbers = value.split('-');
    const validateNumber = makeValidateNumber(min, max);

    return (
      numbers.length === 2 &&
      !numbers.some((n) => !validateNumber(n)) &&
      // Fixed noUncheckedIndexedAccess NIM-19408
      Number.parseInt(numbers[0]!, 10) < Number.parseInt(numbers[1]!, 10)
    );
  };

export const makeValidateNumber =
  (min: number, max: number) =>
  (value: string): boolean => {
    const number = Number.parseInt(value, 10);
    return numberRegex.test(value) && number >= min && number <= max;
  };

export const makeValidateNumberCsv =
  (min: number, max: number) =>
  (value: string): boolean => {
    const numbers = value.split(',');
    const validateRange = makeValidateRange(min, max);
    const validateNumber = makeValidateNumber(min, max);

    return !numbers.some((n) =>
      n.includes('-') ? !validateRange(n) : !validateNumber(n),
    );
  };
